module.exports = __webpack_public_path__ + "img/grid-dots-horizontal-center.210358ec.svg";